import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DxPopoverComponent } from 'devextreme-angular/ui/popover';
import { ConfirmationService, MessageService, PrimeTemplate } from 'primeng/api';
//import { RateOfExchangeProperties } from '../Models/RateOfExchangeProperties';
//import { RateOfExchangeService } from '../Services/rate-of-exchange.service';
import { MasterPassengerInfoService } from '../Services/master-passenger-info.service';
import { SupplierPassengerCriteria } from '../Models/MasterPassengerInfoProperties';
import { NavMenuComponent } from '../nav-menu/nav-menu.component';
import { Bind } from 'primeng/bind';
import { Toast } from 'primeng/toast';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { ButtonDirective } from 'primeng/button';
import { DxDataGridModule, DxPopoverModule } from 'devextreme-angular';
import { DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxoScrollingModule, DxoPagerModule, DxiColumnModule, DxoSearchPanelModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';


@Component({
    selector: 'app-master-passenger-info-list',
    templateUrl: './master-passenger-info-list.component.html',
    styleUrls: ['./master-passenger-info-list.component.css'],
    imports: [NavMenuComponent, Bind, Toast, ConfirmDialog, PrimeTemplate, ButtonDirective, DxDataGridModule, DxoSelectionModule, DxoPagingModule, DxoFilterRowModule, DxoScrollingModule, DxoPagerModule, DxiColumnModule, DxoSearchPanelModule, DxTemplateModule, DxPopoverModule]
})
export class MasterPassengerInfoListComponent implements OnInit {
  @ViewChild(DxPopoverComponent) popOver: DxPopoverComponent;
  /** RateOfExchangeList ctor */
  supplierPassengerCriteria: SupplierPassengerCriteria[] = [];
  popoverTarget: any;
  popOverText: string;
  loader: boolean = false;
  collapsed = false;
  constructor(private confirmationService: ConfirmationService, private service: MasterPassengerInfoService, private messageService: MessageService, private router: Router) {
    this.popoverTarget = "";
    this.popOverText = "hello shoaib";
  }
  contentReady = (e) => {
   /// $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
  ngOnInit() {
    this.getAllSupplierPassengerCriteria();
  }

  //onCellHoverChanged(e) {

  //  if (e.rowType === "data" && e.column.dataField === "agencyBranchList" && e.eventType === "mouseover") {

  //    this.popOverText = e.text;
  //    this.popoverTarget = e.cellElement;
  //    this.popOver.width = "auto";
  //    this.popOver.height = "auto";
  //    this.popOver.visible = true;
  //    this.popOver.position = "top";
  //    this.popOver.instance.show();

  //  }
  //  if (e.rowType === "data" && e.eventType === "mouseout") {
  //    this.popOver.instance.hide();
  //  }
  //}

  DeleteCriteria(id) {
    this.service.DeleteCriteriaById(id).subscribe((data) => {
      if (data == true) {
        this.loader = false;
        this.getAllSupplierPassengerCriteria();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Saved Successfully!' });
      }
      else {
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Not Deleted.' });
      }
    })
  }

  confirmdelete(obj: SupplierPassengerCriteria) {
    let messgae = "";

    //let countss = 0;
    //for (let o = 0; o < this.supplierPassengerCriteria.length; o++) {
    //  if (obj.roeid != this.rateOfExchangeDetails[o].roeid) {
    //    if (obj.supplier == this.rateOfExchangeDetails[o].supplier && obj.officeIDs == this.rateOfExchangeDetails[o].officeIDs) {
    //      countss++;

    //    }
    //  }
    //}

    //if (countss == 0) {
    //  messgae = "Not Any Supplier or PCC is Exist! Please confirm to proceed.";
    //}
    //else {
    //  messgae = "Please confirm to proceed.";
    //}

    messgae = "Please confirm to proceed.";
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: messgae,
      accept: () => {
        this.loader = true;
        this.DeleteCriteria(obj.supPassMasterCriteriaId);

      },
      reject: () => {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
      }
    });
  }

  updateCriteria(id) {
    localStorage.setItem("SupplierCriteriaId", id);
    localStorage.setItem("TypeCriteria", "Update");
    this.router.navigateByUrl("/MasterSupplierPassenger");
  }
  createSupplierPassengerCriteria() {
    localStorage.setItem("TypeCriteria", "Create");
    this.router.navigateByUrl("/MasterSupplierPassenger");
  }

  getAllSupplierPassengerCriteria() {
    this.service.GetAllSupplierMasterPassengerInfo().subscribe((data) => {
      this.supplierPassengerCriteria = data;

    });
  }
}
